<template>
    <el-card class="lesson-resources-enclosures" shadow="never">
        <div slot="header">
            <span>所有文件</span>
            <!-- 课堂所有者 -->
            <div class="card-header-right">
                <el-button type="text" icon="el-icon-folder-add">新建文件夹</el-button>
            </div>
        </div>
        <el-row class="enclosures-list">
            <el-col :span="4" v-for="i in pageSize" :key="i">
                <el-card shadow="hover" :body-style="{ padding: '0px' }">
                    <div class="enclosure">
                        <a class="enclosure-thumbnail">
                            <img src="~@/assets/imgs/star.png">
                        </a>
                        <h5 class="enclosure-name">附件资源-的附件是范德萨发水电费第三方的范德萨</h5>
                        <!-- 课堂所有者 -->
                        <p class="enclosure-info">
                            <span><i>0</i>次下载</span>
                        </p>
                        <p class="enclosure-action">
                            <el-button type="text" size="mini">下载</el-button>
                            <!-- 课堂所有者 -->
                            <template>
                                <el-button type="text" size="mini">移入</el-button>
                                <el-button type="text" size="mini">保存</el-button>
                                <el-dropdown trigger="click">
                                    <el-button class="el-dropdown-link" type="text" size="mini">更多</el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item>使用统计</el-dropdown-item>
                                        <el-dropdown-item>权限设置</el-dropdown-item>
                                        <el-dropdown-item>删除</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </p>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <div class="pagination">
            <el-pagination 
                           layout="total, sizes, prev, pager, next, jumper"
                           :current-page="currentPage"
                           :page-size="pageSize"
                           :pager-count="pagerCount"
                           :total="totalEnclosure"
                           @size-change="sizeChange"
                           @current-change="currentChange">
            </el-pagination>
        </div>
    </el-card>
</template>

<script>
export default {
    data () {
        return {
            currentPage: 1, // 当前页数，支持 .sync 修饰符
            pageSize: 10, // 每页显示条目个数，支持 .sync 修饰符
            pagerCount: 7, // 页码按钮的数量，当总页数超过该值时会折叠(大于等于 5 且小于等于 21 的奇数)
            totalEnclosure: 100, // 总条目数
        }
    },
    methods: {
        // pageSize 改变时会触发
        sizeChange (pageSize) {
            this.pageSize = pageSize
        },
        // currentPage 改变时会触发
        currentChange (currentPage) {
            this.currentPage = currentPage
        }
    }
}
</script>


<style lang="less" scoped>
.lesson-resources-enclosures {
    .card-header-right {
        float: right;
        .el-button {
            padding: 0;
        }
    }
    .enclosures-list {
        [class*=el-col-] {
            padding: 6px;
        }
        .enclosure {
            padding: 10px 5px;
            &-thumbnail {
                width: 100%;
                height: 96px;
                line-height: 96px;
                display: inline-block;
                text-align: center;
                cursor: pointer;
                img {
                    max-width: 100%;
                    max-height: 100%;
                }
            }
            &-name {
                line-height: 2em;
                font-weight: normal;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                cursor: pointer;
            }
            &-info,
            &-action {
                font-size: 0.7rem;
                text-align: center;
                height: 28px;
                line-height: 28px;
            }
            &-info {
                color: #ababab;
                > span {
                    i {
                        font-style: normal;
                    }
                }
            }
            &-action {
                display: none;
                * {
                    & + * {
                        margin-left: 6px;
                    }
                }
            }
            &:hover {
                .enclosure-info {
                    display: none;
                }
                .enclosure-action {
                    display: block;
                }
            }
        }
        & + .pagination {
            text-align: center;
            margin-top: 20px;
        }
    }
}
</style>
